import { css } from '@emotion/react';
import type { Theme } from '~/_shared/themes/theme.model';
import type { Place } from '~/places/places.types';
import { getPlacesToolCircleColors } from './placesTool.helpers';
import { placeCircleStyle } from './placesTool.styles';

const containerStyle = (theme: Theme) => css({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  gap: 8,
  padding: '12px 10px',
  border: `1px solid ${theme.accordionColors.borderColor}`,
});

const leftStyle = css({
  width: 20,
  flexShrink: 0,
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 6,
});

const centerStyle = (theme: Theme) => css({
  flexGrow: 1,
  flexBasis: 0,
  display: 'flex',
  flexDirection: 'column',
  gap: 6,
  color: theme.textColors.primary,
});

const placeTitleStyle = css({
  fontSize: 16,
});

const placeMoreInfoStyle = css({
  fontSize: 12,
});

const rightStyle = css({
  width: 20,
  flexShrink: 0,
});

export const PlacesListingPlaceDetailsComponent = ({
  color,
  place,
  index,
  onHover,
  onHoverStopped,
}: {
  color: string;
  place: Place;
  index: number;
  onHover: () => void;
  onHoverStopped: () => void;
}) => {

  return (
    <div
      onMouseEnter={onHover}
      onMouseLeave={onHoverStopped}
      css={containerStyle}
    >
      <div css={leftStyle}>
        {/*<div> // this is being added in phase 2
          <CheckboxComponent
            checkedSetter={noop}
            isChecked={false}
          />
        </div>
        */}
        <div
          css={placeCircleStyle(getPlacesToolCircleColors(color))}
        >
          {index + 1}
        </div>
      </div>
      <div css={centerStyle}>
        <div css={placeTitleStyle}>{place.name}</div>
        <div css={placeMoreInfoStyle}>{place.address}</div>
      </div>
      <div css={rightStyle}>
        {/* trashcan icon will be here */}
      </div>
    </div>
  );
};
